import styled from 'styled-components';
import { HeadingOne } from '../styles/common/typo.styles';
import { styledComponentProps } from '../types/theme';
import { BiuRoundedButton } from '../biu-web-components/src/components';

export const BackgroundView = styled.div`
	background-color: #f3f4f8;
	min-height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: ${({ theme }: styledComponentProps): string => theme.text.fontFamily}
`;

export const Container = styled.div`
	background-color: #f3f4f8;
	max-width: 1156px;
	margin: 0 auto;
	padding: 50px 0px;

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		max-width: calc(100% - 120px);
	}
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
		max-width: calc(100% - 80px);
	}

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		max-width: 100%;
	}
`;

export const H1 = styled(HeadingOne)`
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		margin-right: 30px;
	}
`;

export const Group = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const PastButton = styled(BiuRoundedButton)<any>`
	margin-right: ${({ direction }: any) =>
		direction === 'rtl' ? '24px' : 'unset'};
	margin-left: ${({ direction }: any) =>
		direction === 'rtl' ? 'unset' : '24px'};
	
	.biu-rounded-button__icon {
		display: none;
	}
	.biu-rounded-button__label {
		color: #01280f;
	}
`;
